import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "../styling/App.css";
import LeftPanelClientPortal from "./panels/LeftPanelClientPortal";
import ClientLandingPageBusiness from "./clientPortal/ClientLandingPageBusiness";

const BusinessClientContainer = ({
  clientId,
  onEventClick,
  setInitialBusinessEventTab,
}) => {
  const id = clientId;
  const [client, setClient] = useState({});
  const [brandingColours, setBrandingColours] = useState({
    primaryColor: "#008000",
    secondaryColor: "#dddddd",
  });
  const [selectedTab, setSelectedTab] = useState("landing"); // Flag to control which set of tabs is shown
  const [events, setEvents] = useState([]);
  const [brandLogo, setBrandLogo] = useState(null);
  const [showAccountInfo, setShowAccountInfo] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const businessId = searchParams.get("businessId");

  // Fetch client data and branding on component mount
  useEffect(() => {
    const fetchClientData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/clientInfo/${id}`,
          {
            withCredentials: true,
          }
        );
        setClient(response.data.data);
      } catch (error) {
        console.log("Error fetching client data: ", error);
      }
    };

    const fetchBusinessBranding = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/client/get-branding`,
          {
            businessId: businessId,
          },
          { withCredentials: true }
        );

        // Update branding colors
        const { primaryColor, secondaryColor, brandLogo } = response.data;
        setBrandingColours({ primaryColor, secondaryColor });
        setBrandLogo(brandLogo);
      } catch (error) {
        console.log("Error fetching branding data: ", error);
      }
    };

    const fetchEventData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/client/eventsInfo/${id}`,
          { withCredentials: true }
        );

        setEvents(response.data.data);
      } catch (error) {
        console.log("Error fetching branding data: ", error);
      }
    };

    fetchClientData().then(() => {
      fetchEventData();
      if (businessId) {
        fetchBusinessBranding({ businessId });
      }
    });
  }, [id]);

  // Handle tab switch between landing page and portal
  const handleTabSwitch = (tab) => {
    setSelectedTab(tab);
  };

  const handleBacktoAccount = () => {
    setSelectedTab("landing");
  };

  return (
    <div className="client-container">
      <div style={{ backgroundColor: "#f2f2f2" }}>
        <div className="main-content">
          <div className="clientProfileDetails">
            {/* Left Panel stays constant */}
            <LeftPanelClientPortal
              handleBackToAccount={handleBacktoAccount}
              clientData={client}
              brandingColours={brandingColours}
              selectedTab={selectedTab}
            />
          </div>

          <div className="clientLandingTabs">
            <ClientLandingPageBusiness
              brandingColours={brandingColours}
              handleTabSwitch={handleTabSwitch}
              events={events}
              clientId={clientId}
              onEventClick={onEventClick}
              clientData={client}
              setInitialBusinessEventTab={setInitialBusinessEventTab}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessClientContainer;
